module.exports = [
  {
    id: "personio",
    title: "Personio",
    color: "#FFD600",
    shortDescription: "The People Operating System",
    description:
      "Personio simplifies every step of the employee journey from recruiting right through to offboarding in one single, powerful solution. Get top-rated applicant tracking, talent management and core HR in one place so you can save time for more strategic work.",
    icon: require("@/assets/images/icons/app-marketplace/integrations/personio.svg"),
    categories: ["hris"],
  },
  {
    id: "paylocity",
    title: "Paylocity",
    color: "#FFD600",
    shortDescription: "Payments with HR Software",
    description:
      "At Paylocity, caring is in our makeup. It's who we are. We're more than a cutting-edge HR and payroll tech company with crazy good reviews (just sayin'). We're people. Because people matter most. And people have always been at the heart of our business.",
    icon: require("@/assets/images/icons/app-marketplace/integrations/paylocity.svg"),
    categories: ["hris"],
  },
  {
    id: "hibob",
    title: "HiBob",
    color: "#D33F55",
    shortDescription: "Streamline HR processes",
    description:
      "Bob is an HRIS (Human Resource Information System) that stores, manages, and tracks employee-related data.\n From out-of-the-box onboarding, workflows, performance management, and compensation management to integrations with leading payroll providers and more—Bob's breadth of core HR functionally gives your team everything needed to operate efficiently.",
    icon: require("@/assets/images/icons/app-marketplace/integrations/hibob.svg"),
    categories: ["hris"],
  },
  // {
  //   id: "sap",
  //   title: "SAP",
  //   color: "#FFD600",
  //   shortDescription: "Unified core business system",
  //   description:
  //     "SAP ERP is an enterprise resource planning software developed by the German company SAP SE. SAP ERP incorporates the key business functions of an organization.",
  //   icon: require("@/assets/images/icons/app-marketplace/integrations/sap.svg"),
  //   categories: ["hris"],
  // },
  {
    id: "sap-successfactors",
    title: "SAP SuccessFactors",
    color: "#FFD600",
    shortDescription: "Leading Education Counseling Service",
    description:
      "Success Factor is a top-rated higher education boutique university counseling and placement service with its operations currently running from Islamabad, Lahore, Karachi as well as Sialkot. From its foundation in 1997 as study abroad consultants, Success Factor has been thriving to change the dynamics of education counseling in Pakistan",
    icon: require("@/assets/images/icons/app-marketplace/integrations/successfactor.jpg"),
    categories: ["hris"],
  },
  {
    id: "workday",
    title: "Workday",
    color: "#FFD600",
    shortDescription: "Finance & HR Fusion",
    description:
      "Workday unites finance and HR on one platform where AI and continuous innovation are built into the core. It's how we help customers empower their people, make fast, confident decisions, and drive flawless operations to move business forever forward.",
    icon: require("@/assets/images/icons/app-marketplace/integrations/workday.png"),
    categories: ["hris"],
  },
];
